export const listVins = (vins) => {
  return {
    type: "LIST_VINS",
    payload: vins,
  };
};

export const FilterlistVins = (filterVins) => {
  return {
    type: "FILTER_LIST_VINS",
    payload: filterVins,
  };
};

export const SearchVins = (searchVins) => {
  return {
    type: "SEARCH_VINS",
    payload: searchVins,
  };
};

export const VinsDetails = (vinDetails) => {
  return {
    type: "DETAILS_VINS",
    payload: vinDetails,
  };
};

export const VinCount = (vinCountDetails) => {
  return {
    type: "VINS_COUNT",
    payload: vinCountDetails,
  };
};

export const VinParkedStatus = (vinParkStatus) => {
  return {
    type: "VINS_PARKED_STATUS",
    payload: vinParkStatus,
  };
};

export const VinAgingCount = (vinAgingCount) => {
  return {
    type: "VINS_AGING_COUNT",
    payload: vinAgingCount,
  };
};